import styles from './CollapsableButton.module.css';
import { IconButton, IIconButton } from '../IconButton';
import { classNames } from '@axo/shared/util/dom';

interface CollapsedButtonProps extends IIconButton {
  collapsed?: boolean;
}

const CollapsableButton = ({
  classes,
  collapsed,
  children,
  ...props
}: CollapsedButtonProps) => {
  return collapsed ? (
    <div className={styles.collapsedItem}>
      <IconButton
        classes={{
          ...classes,
          root: classNames(styles.collapsedButton, classes?.root),
        }}
        {...props}
      />
    </div>
  ) : (
    <>{children}</>
  );
};

export default CollapsableButton;
